import React, { ReactElement } from 'react';

import { TextRegular } from '../../components/Text';
import TInputLabel from './TInputLabel';

const InputLabel = ({ htmlFor, isInputRequired, labelText, optionalText }: TInputLabel): ReactElement => (
  <>
    <TextRegular as="label" color="text-primary" strong={true} htmlFor={htmlFor} className="input-label">
      {labelText}
      {!isInputRequired && optionalText && (
        <TextRegular as="span" color="text-secondary" utilities={['marginLeftXxxs']}>
          {`(${optionalText})`}
        </TextRegular>
      )}
    </TextRegular>
  </>
);

export default InputLabel;
